export function getTimeOutException(message: string){
    if(message.includes('TimeoutException')){
        return "web.api.error.status.gatewayTimeout"
    }
    else{
        return message
    }
}